import useMedia from 'use-media';

export const useSmall = () => useMedia({ maxWidth: '640px' });
export const useMedium = () => useMedia({ maxWidth: '768px' });
export const useLarge = () => useMedia({ maxWidth: '1024px' });
export const useXLarge = () => useMedia({ maxWidth: '1280px' });
